export default "__VITE_ASSET__YW90VgwN__"